module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v(" STRANGE FIRE ")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct3",
    attrs: {
      "id": "p0007-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])]), _c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('p', {
    staticClass: "ser1"
  }, [_c('img', {
    staticClass: "maxwidth",
    attrs: {
      "alt": "978140020518_0007_002.jpg",
      "src": "images/978140020518_0007_002.jpg"
    }
  })])]), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter3#tt3",
      "id": "ii3"
    }
  }, [_c('i', [_vm._v("Introduction: For the Sake of His Name")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter4#tt4",
      "id": "ii4"
    }
  }, [_vm._v("Part 1: Confronting a Counterfeit Revival ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter5#tt5",
      "id": "ii5"
    }
  }, [_vm._v("1. Mocking the Spirit ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter6#tt6",
      "id": "ii6"
    }
  }, [_vm._v("2. A New Work of the Spirit? ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#tt7",
      "id": "ii7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Testing the Spirits (Part 1) ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#tt8",
      "id": "ii8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Testing the Spirits (Part 2) ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#tt9",
      "id": "ii9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: Exposing the Counterfeit Gifts ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#tt10",
      "id": "ii10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Apostles Among Us? ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#tt11",
      "id": "ii11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Folly of Fallible Prophets ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#tt12",
      "id": "ii12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Twisting Tongues ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#tt13",
      "id": "ii13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Fake Healings and False Hopes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#tt14",
      "id": "ii14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3: Rediscovering the Spirit’s True Work ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#tt15",
      "id": "ii15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Holy Spirit and Salvation ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1a"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#tt16",
      "id": "ii16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Spirit and Sanctification ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1a"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#tt17",
      "id": "ii17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Spirit and the Scriptures ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1a"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#tt18",
      "id": "ii18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. An Open Letter to My Continuationist Friends ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chapter19#tt19",
      "id": "ii19",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#tt20",
      "id": "ii20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix: Voices from Church History")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#tt21",
      "id": "ii21",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/index1#ttindex1",
      "id": "iiindex1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/index2#ttindex2",
      "id": "iiindex2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Scripture Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#tt22",
      "id": "ii22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6036e0db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 69
// module chunks = 0